import { render, staticRenderFns } from "./karta.vue?vue&type=template&id=1505fec8&"
import script from "./karta.vue?vue&type=script&lang=js&"
export * from "./karta.vue?vue&type=script&lang=js&"
import style0 from "./karta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports